<template>
<section class="page-about-us">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-about-box">
    <div class="qbk-wrap">
      <h4>Meeting Room</h4>
      <div class="row qbk-abs-content">
        <div class="col-12 col-md-6">
          <h1 class="mb-3">{{post.data.title}}</h1>
        </div>
        <div class="col-12 col-md-6" v-html="post.data.content">

        </div>
      </div>
      <div class="row qbk-abs-content">
        <div class="col-12">
          <b-carousel id="carousel-1" :interval="4000" indicators background="#ababab" img-width="1024" img-height="480" style="text-shadow: 1px 1px 2px #333;">
            <b-carousel-slide>
              <template #img>
                <img class="d-block img-fluid w-100" width="1024" height="480" :src="post.data.image" alt="image slot">
              </template>
            </b-carousel-slide>
            <b-carousel-slide v-for="(oIm,oImIndex) in post.data.child.image" :key="`oIm-${oImIndex}`">
              <template #img>
                <img class="d-block img-fluid w-100" width="1024" height="480" :src="oIm.image" alt="image slot">
              </template>
            </b-carousel-slide>
          </b-carousel>
          <!-- <img src="../assets/images/banner-3.png" alt="" class="img-fluid w-100"> -->
        </div>
      </div>
      <h4>What do We Offer?</h4>
      <div class="row qbk-abs-content qbk-border-bot" v-for="(oFac,oFacIndex) in post.data.child.facility" :key="`oFac-${oFacIndex}`">
        <div class="col-12 col-md-6">
          <h1 class="mb-3">{{oFac.title}}</h1>
        </div>
        <div class="col-12 col-md-6" v-html="oFac.content">
        </div>
      </div>
      <!-- <h4>Meet Our Team</h4>
        <div class="qbk-team">
          <div class="row no-gutters">
            <div class="col">
              <hooper :settings="hooperSettings">
                <slide v-for="(x,index) in 3" :key="'qbk-hooper-team-'+index">
                  <div class="qbk-team-item">
                    <img :src="require('../assets/images/team-'+x+'.png')" alt="Hotel" class="img-fluid w-100">
                    <h1>Mr. Name</h1>
                    <h3>CEO</h3>
                  </div>
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
          </div>
        </div> -->
      <!-- <div class="qbk-about-adv">
          <h1>Make a room for adventure!</h1>
          <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ulla</p>
          <router-link to="/book">Book Your Room Now</router-link>
        </div> -->
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios'
import {
  baseUrl
} from '../config'
// import {
//     Hooper,
//     Slide,
//     Navigation as HooperNavigation
// } from 'hooper';
export default {
  name: 'aboutus',
  components: {
    // Hooper,
    // Slide,
    // HooperNavigation
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 3,
        itemsToSlide: 3,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 5000,
        breakpoints: {
          0: {
            itemsToSlide: 1,
            itemsToShow: 1
          },
          800: {
            itemsToSlide: 3,
            itemsToShow: 3
          },
          1000: {
            itemsToSlide: 3,
            itemsToShow: 3
          }
        }
      },
      post: {
        loading: false,
        data: {
          id: null,
          image: null,
          title: null,
          content: null,
          id_parent: null,
          type: 'MEETING ITEM',
          child: {
            image: [],
            facility: []
          }
        },
        deleteId: null
      }
    };
  },
  methods: {
    loadPost() {
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage: '~',
        type: 'MEETING ITEM'
      }
      axios
        .post(url, payload)
        .then((res) => {
          if (res.data.data.length > 0) {
            let resData = res.data.data[0]
            this.post.data.id = resData.id
            this.post.data.image = resData.image
            this.post.data.title = resData.title
            this.post.data.content = resData.content
            this.post.data.id_parent = resData.id_parent
            this.post.data.type = 'MEETING ITEM'
            this.post.data.child.facility = []
            this.post.data.child.image = []
            resData.child.map((z) => {
              switch (z.type) {
                case 'MEETING ITEM FACILITY':
                  z.deleted = false
                  this.post.data.child.facility.push(z)
                  break;
                case 'MEETING ITEM IMAGES':
                  z.deleted = false
                  this.post.data.child.image.push(z)
                  break;
              }
            })
          }
        })
        .catch((e) => {
          this.notif('Error', e.message, 'error')
        })
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  },
  mounted() {
    this.loadPost()
  }
}
</script>
